export default __webpack_public_path__ + "static/media/menu-top.39cad0bb.png";